module.exports = __webpack_public_path__ + "media/empty-states/expo-2x-90b07157.png";